import styled from '@emotion/styled';
import { Chip } from '@mui/material';
import { FaPaperPlane } from 'react-icons/fa';
import { WsColors, WsIconClockHour2, WSIconTickMark } from 'wisestep-base';

const StyledIconChip = styled(Chip)(
  ({ textColor, bgColor }: { textColor: string; bgColor: string }) => ({
    color: textColor,
    background: bgColor,
    fontSize: 14,
    fontWeight: 500,
    paddingLeft: 12,
    paddingRight: 12,
    borderRadius: 10,
  })
);

export const enum ChipIconVariants {
  ACTIVE,
  INACTIVE,
  QUEUED,
  SENT,
}

interface StatusIconChipProps {
  label: string;
  variant: ChipIconVariants;
}

const variantConfig = {
  [ChipIconVariants.ACTIVE]: {
    icon: <WSIconTickMark color={WsColors.Green800} width={18} height={18} />,
    bgcolor: WsColors.BackGroundGreenLight,
    color: WsColors.TextGreen,
  },
  [ChipIconVariants.INACTIVE]: {
    icon: <WsIconClockHour2 color={WsColors.IconLight} width={18} height={18} />,
    bgcolor: WsColors.BackGroundGreyLight,
    color: WsColors.TextLight,
  },
  [ChipIconVariants.QUEUED]: {
    icon: <WsIconClockHour2 color={WsColors.INFORMATION800} width={18} height={18} />,
    bgcolor: WsColors.SkyBlueTint,
    color: WsColors.TEXTBLUE,
  },
  [ChipIconVariants.SENT]: {
    icon: <FaPaperPlane color={WsColors.Green800} size={15} style={{ margin: 0 }} />,
    bgcolor: WsColors.BackGroundGreenLight,
    color: WsColors.TextGreen,
  },
};

export const StatusIconChip = ({ label, variant }: StatusIconChipProps) => {
  return (
    <StyledIconChip
      size="small"
      label={label}
      icon={variantConfig[variant].icon}
      textColor={variantConfig[variant].color}
      bgColor={variantConfig[variant].bgcolor}
    />
  );
};
